import { createContext, useContext, useEffect, useState } from "react";
import config from "../devprodConfig";

const UserContext = createContext(null);

export function UserProvider({ children }) {
  const [meUser, setMeUser] = useState(null);
  const [localUser, setLocalUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // -------------------- FETCH WITH TIMEOUT --------------------
  const fetchWithTimeout = (url, options, timeout = 20000) =>
    new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error("Request timed out")), timeout);
      fetch(url, options)
        .then((res) => {
          clearTimeout(timer);
          resolve(res);
        })
        .catch((err) => {
          clearTimeout(timer);
          reject(err);
        });
    });

  // -------------------- LOAD JWT USER (/me) --------------------
  const loadMeUser = async () => {
    try {
      const res = await fetchWithTimeout(`${config.apiBaseUrl}/me`, {
        credentials: "include",
      }, 5000); // 5s timeout

      if (!res.ok) {
        setMeUser(null);
        setLocalUser(null);
        return null;
      }

      const user = await res.json();
      setMeUser(user);
      setLocalUser(user);
      return user;
    } catch (err) {
      console.error("❌ loadMeUser:", err);
      setMeUser(null);
      setLocalUser(null);
      return null;
    } finally {
      setLoading(false); 
    }
  };

  // -------------------- REFRESH USER --------------------
  const refreshUser = async () => {
    setLoading(true);
    await loadMeUser();
  };

  // -------------------- REFRESH LOCAL ONLY --------------------
  const refreshLocalUser = async () => {
    setLoading(true);
    await loadMeUser();
  };

  // -------------------- LOGOUT --------------------
  const logout = () => {
    setMeUser(null);
    setLocalUser(null);
    setLoading(false);
  };

  // -------------------- INITIAL LOAD --------------------
  useEffect(() => {
    refreshUser();
  }, []);

  return (
    <UserContext.Provider
      value={{
        meUser,
        localUser,
        loading,
        refreshUser,
        refreshLocalUser,
        logout,
      }}
    >
      {children}
    </UserContext.Provider>
  );
}

export const useUser = () => useContext(UserContext);